import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ClientProvider } from './contexts/ClientContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { PersistedQueryClientProvider } from './lib/queryPersistence';
import './index.css';
import 'react-calendar/dist/Calendar.css';     // library default
import './styles/calendar.patch.css';  
import './styles/toast.css';
import { logRuntimeConfig, assertProductionBaseUrl } from './config/runtime';

import axios from 'axios';   

axios.defaults.withCredentials = true;

// CRITICAL: Initialize and verify runtime configuration at app startup
// This ensures baseURL is correctly resolved and prevents localhost in production
try {
  logRuntimeConfig();
  assertProductionBaseUrl();
} catch (err: any) {
  console.error('[App Startup] Runtime configuration error:', err.message);
  // In production, this will prevent the app from starting with invalid config
  // In development, we continue but log the error
  if (process.env.NODE_ENV === 'production') {
    throw err;
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // NOTE: React.StrictMode double-invokes effects in development mode.
  // This is intentional and helps catch bugs, but it means useEffect hooks run twice in dev.
  // This is NORMAL behavior and is unrelated to backend 500 errors.
  // To temporarily disable for debugging, wrap with: {process.env.NODE_ENV === 'production' ? <App /> : <StrictMode><App /></StrictMode>}
  // However, we recommend keeping StrictMode enabled to catch potential issues.
  <React.StrictMode>
    <PersistedQueryClientProvider>
      <LanguageProvider>
        <ClientProvider>
          <App />
        </ClientProvider>
      </LanguageProvider>
    </PersistedQueryClientProvider>
  </React.StrictMode>
);